import React, { useEffect, useState, useRef } from "react";
import "./InfiniteMovingCards.css";

const InfiniteMovingCards = ({
  items,
  direction = "left",
  speed = "fast",
  pauseOnHover = true,
}) => {
  const containerRef = useRef(null);
  const scrollerRef = useRef(null);
  const [start, setStart] = useState(false);

  useEffect(() => {
    addAnimation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const addAnimation = () => {
    if (containerRef.current && scrollerRef.current) {
      const scrollerContent = Array.from(scrollerRef.current.children);

      scrollerContent.forEach((item) => {
        const duplicatedItem = item.cloneNode(true);
        if (scrollerRef.current) {
          scrollerRef.current.appendChild(duplicatedItem);
        }
      });

      getDirection();
      getSpeed();
      setStart(true);
    }
  };

  const getDirection = () => {
    if (containerRef.current) {
      if (direction === "left") {
        containerRef.current.style.setProperty(
          "--animation-direction",
          "forwards"
        );
      } else {
        containerRef.current.style.setProperty(
          "--animation-direction",
          "reverse"
        );
      }
    }
  };

  const getSpeed = () => {
    if (containerRef.current) {
      if (speed === "fast") {
        containerRef.current.style.setProperty("--animation-duration", "20s");
      } else if (speed === "normal") {
        containerRef.current.style.setProperty("--animation-duration", "40s");
      } else {
        containerRef.current.style.setProperty("--animation-duration", "120s");
      }
    }
  };

  return (
    <div
      ref={containerRef}
      className={`scroller ${pauseOnHover ? "pause-on-hover" : ""}`}
    >
      <ul
        ref={scrollerRef}
        className={`scroller-inner ${start ? "animate-scroll" : ""}`}
      >
        {items.map((item, idx) => (
          <li className="testimonial-card" key={idx}>
            <blockquote>
              <div className="testimonial-author" style={{ marginBottom: "0.75rem" }}>
                <div className="author-avatar">
                  {item.image ? (
                    <img
                      src={item.image}
                      alt={item.name}
                      style={{
                        width: "36px",
                        height: "36px",
                        borderRadius: "50%",
                        objectFit: "cover",
                        border: "2px solid var(--accent-primary)",
                      }}
                    />
                  ) : (
                    <svg
                      width="36"
                      height="36"
                      viewBox="0 0 40 40"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx="20" cy="20" r="20" fill="var(--accent-primary)" opacity="0.2" />
                      <path
                        d="M20 20C22.7614 20 25 17.7614 25 15C25 12.2386 22.7614 10 20 10C17.2386 10 15 12.2386 15 15C15 17.7614 17.2386 20 20 20Z"
                        fill="var(--accent-primary)"
                      />
                      <path
                        d="M20 22C15.5817 22 12 25.5817 12 30C12 30.5523 12.4477 31 13 31H27C27.5523 31 28 30.5523 28 30C28 25.5817 24.4183 22 20 22Z"
                        fill="var(--accent-primary)"
                      />
                    </svg>
                  )}
                </div>
                <span className="author-info">
                  <span className="author-name">{item.name}</span>
                  <span className="author-title">{item.title}</span>
                </span>
              </div>
              <span className="testimonial-quote">"{item.quote}"</span>
            </blockquote>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default InfiniteMovingCards;
